export default __webpack_public_path__ + "locales/cs/Notifications.json?hash=77988184bd3f31f3a8a2178567a8bc5f";